import { styled } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import WorkAgreement, {
  Masked,
  WorkAgreementFieldCategory
} from "work/entities/work-agreement/work-agreement";
import FeeScheduleCategory, {
  FeeScheduleCategoryMaskedCurrency
} from "work/values/fee-schedule-category/fee-schedule-category";
import FeeScheduleCategoriesReadonly from "work/values/fee-schedule-category/view/fee-schedule-categories-readonly";

const ListContainer = styled(Grid)(
  () => ({
    minHeight: "20rem",
  }));
const CategorySelection = styled(FeeScheduleCategoriesReadonly)(
  ({ theme }) => ({
    [theme.breakpoints.down("lg")]: {
      marginTop: theme.spacing(2),
    },
    height: "100%",
    marginLeft: theme.spacing(2),
  }));

type FeeScheduleTabProps = {
  activeTab: WorkAgreementFieldCategory;
  workAgreement: WorkAgreement;
};

export default function FeeScheduleTab(
  props: Readonly<FeeScheduleTabProps>
) {
  const {
    activeTab,
    workAgreement
  } = props;

  const [selectedCategories, setSelectedCategories] = useState<FeeScheduleCategory[] | FeeScheduleCategoryMaskedCurrency[]>([]);

  useEffect(
    () => {
      if (activeTab !== WorkAgreementFieldCategory.FeeSchedule) return;
      if (Masked.isMasked(workAgreement.feeSchedule)) return;

      setSelectedCategories(workAgreement.feeSchedule ?? []);
    },
    [
      workAgreement,
      activeTab
    ]
  );

  if (activeTab !== WorkAgreementFieldCategory.FeeSchedule) return null;

  return (
    <ListContainer container direction="row">
      <Grid size="grow">
        <CategorySelection
          categories={selectedCategories}
          hideCommentButton={true}
        />
      </Grid>
    </ListContainer>
  );
}
